import React from "react";
import type { ChatMessage } from "../annotations/WhatsAppAnnotations";
import Messages from "./Messages";

interface Props {
  dateKey: string;
  messages: ChatMessage[];
}

const DateGroup: React.FC<Props> = ({ dateKey, messages }) => (
  <div>
    <div className="chat-date-separator text-center">
      <span className="chat-date-badge fw-bold">{dateKey}</span>
    </div>
    {messages.map((msg, index) => (
      <Messages key={msg.id || index} msg={msg} />
    ))}
  </div>
);

export default DateGroup;
